<template>
  <div class="ui basic container segment">
    <div class="ui form" id="instance_form"></div>
  </div>
</template>

<script>
import filters from "@/filters";
import Vue from "vue";
import { local_api, error_toast } from "@/utils";
import { clone } from "lodash";
// import { success_toast } from "@/utils";

export default {
  name: "NgineWorkspaceTaskViewer",
  filters: filters,
  components: {},
  data: function() {
    return {
      user_task_vue: undefined,
    };
  },
  computed: {
    // task_title() {
    //   if (this.task) return ` | ${this.task.title}`;
    //   else return "";
    // },
  },
  methods: {
    preload(process_key, start_point) {
      let vm = this;
      local_api(vm, "post", "/ngine_workspace/external/do-preload-start", {
        k: process_key,
        s: start_point,
      })
        .then((rpreload) => {
          let html = `<div class="ui basic icon labeled button"
                    v-for="(outcome, index) in outcomes"
                    :key="index"
                    style="margin-bottom: 20px"
                    @click="submit_data(outcome)"
                  >
                    <i :class="outcome.icon + ' icon'"></i> {{ outcome.name }}
                  </div>${rpreload.html}<div class="ui error message" />`;

          window.jQuery("#instance_form").html(html);

          var mixin = {};
          // eslint-disable-next-line no-unused-vars
          var fields = {};
          // eslint-disable-next-line no-unused-vars
          var validate_on = [];
          try {
            // eslint-disable-next-line no-unused-vars
            var moment = require("moment");
            console.log("initializing modifiers");
            rpreload.modifiers
              .filter((m) => m.type == "js")
              .map((m) => {
                eval(m.code);
              });

            console.log("initializing vue error handler");
            Vue.config.errorHandler = function(err) {
              error_toast(
                `${vm.$t(
                  "an error ocurred during screen initialization",
                )}. ${vm.$t("error")}: ${err.toString()}`,
              );
              vm.$refs.container.set_loading(false);
            };

            console.log("code mixin");
            if (rpreload.mixin) eval(`mixin = ${rpreload.mixin}`);

            console.log("initializing vue object");
            vm.user_task_vue = new Vue({
              el: "#instance_form",
              data: function() {
                return {
                  outcomes: rpreload.outcomes,
                };
              },
              filters: filters,
              mixins: [mixin],
              methods: {
                submit_data(outcome) {
                  console.log("submit data with outcome", outcome);
                  let vm_ = this;
                  // if (outcome.validate) {
                  //   if (_task.setup.human_task.validation)
                  //     eval(`fields = ${_task.setup.human_task.validation}`);
                  //   vm_.form
                  //     .form({
                  //       fields: fields,
                  //       onSuccess() {
                  vm_.do_submit(outcome);
                  //       },
                  //     })
                  //     .form("validate form");
                  // } else {
                  //   vm_.do_submit(outcome);
                  // }
                },
                do_submit(outcome) {
                  console.log("do submit with outcome", outcome);
                  let vm_ = this;
                  // vm.$refs.container.set_loading(true);

                  let data = clone(vm_.$data);
                  // delete data.V;
                  delete data.outcomes;
                  // delete data.form;

                  local_api(vm, "post", "/ngine_workspace/external/do-start", {
                    k: process_key,
                    s: start_point,
                    d: data,
                    o: outcome.name,
                  })
                    .then((r) => {
                      // vm.$emit("submitted", r);
                      console.log("submited", r);
                    })
                    .catch((err) => {
                      error_toast(err);
                    });
                },
              },
              mounted() {
                console.log("mounted vue object");
                // let vm_ = this;
                // vm.$refs.container.set_loading(false);
                // vm_.form = window.jQuery(vm_.$el).form();
              },
            });
          } catch (error) {
            console.error(error);
            error_toast(error);
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    let vm = this;

    let process_key = vm.$route.query.i;
    let start_point = vm.$route.query.s;
    // console.log("process_key", process_key);
    // console.log("start_point", start_point);

    vm.preload(process_key, start_point);
  },
  watch: {},
};
</script>
